// Modules
import { useFormContext } from "react-hook-form"

// Components
import ImageUpload from "~components/imageUpload/ImageUpload"
import { WizardRow, WizardStepContainer } from "~styled/wizard"
import { ERROR_MESSAGES } from "~constants/errorMessages"

interface StepProps {
  isVisible: boolean
}

const PerkModalStep5 = ({ isVisible }: StepProps) => {
  const { register, setValue, getValues, unregister, formState: { errors } } = useFormContext()

  return (
    <WizardStepContainer className={isVisible ? "visible" : ""}>
      <WizardRow style={{ marginBottom: 20 }}>
        <ImageUpload
          className={"logo"}
          key="logo"
          name="logo"
          label="Select your logo"
          required={false}
          preview={true}
          customErrorMessage={errors.logo && ERROR_MESSAGES.FIELD_REQUIRED}
          {...{ register, setValue, getValues, unregister }}
          removeIcon={false}
        />
      </WizardRow>
      <WizardRow>
        <ImageUpload
          className={"cover"}
          key="cover"
          name="cover"
          label="Select your cover image"
          required={false}
          {...{ register, setValue, getValues, unregister }}
        />
      </WizardRow>
    </WizardStepContainer>
  )
}

export default PerkModalStep5
